module.exports = __webpack_public_path__ + "img/中繼站1_遊戲背景.478e7fda.png";